import { render, staticRenderFns } from "./evidencia-profesiograma.vue?vue&type=template&id=625248e1&scoped=true&"
import script from "./evidencia-profesiograma.vue?vue&type=script&lang=js&"
export * from "./evidencia-profesiograma.vue?vue&type=script&lang=js&"
import style0 from "./evidencia-profesiograma.vue?vue&type=style&index=0&id=625248e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625248e1",
  null
  
)

export default component.exports